// This can be used to mask text
const Formats = {
  numberToCurrency(number, skipDecimals, currencySymbol) {
    let currency = Number(number)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    if (skipDecimals) {
      currency = currency.split('.')[0];
    }
    return `${currencySymbol || ''}${currency}`;
  }
}

export default Formats